import { get, cloneDeep, set } from 'lodash-es';
import * as types from './ExpansionPanelBlock.actionTypes';

/**
 * Reducer
 * @param {*} state
 * @param {*} action
 */
const reducer = (state, action) => {
  try {
    const { type } = action;
    let newState = cloneDeep(state);
    switch (type) {
      //
      case types.SET_EXPANDED: {
        // const {  } = action;
        const expanded = !get(newState, 'expanded');
        set(newState, 'expanded', expanded);
        set(newState, 'noDispatch', false);
        break;
      }
      case types.UPDATE: {
        const { data } = action;
        newState = { ...data, noDispatch: true };
        break;
      }
      default:
        // eslint-disable-next-line no-console
        console.error(`Unexpected action`);
        return state;
    }

    // console.log('newState', newState);
    return newState;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`reducer: ${e.stack}`);
  }
  return state;
};

export default reducer;
